import React from "react";
import { Button, Grid, IconButton, Paper, Table, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert } from "@material-ui/lab";
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Link as RouterLink } from 'react-router-dom';
const useStyles = makeStyles(theme => ({
    head: {
        marginBottom: theme.spacing(3),
    },
    gridPage: {
        padding: "16px",
    },
    page: {
        width: "100%",
    }
}));
export const AdminListWrapper = ({ title, addText, addAction, headerChildren, page = 1, setPage, resource, children }) => {
    function handleClick(e) {
        if (typeof addAction === "function") {
            e.preventDefault();
            addAction();
        }
    }
    const style = useStyles();
    const contentAvailable = (setPage && resource["content"]) ? resource["content"].length > 0 : resource.length > 0;
    return React.createElement(React.Fragment, null,
        React.createElement(Grid, { className: style.head, alignItems: "flex-end", container: true, spacing: 3, justifyContent: "space-between" },
            React.createElement(Grid, { item: true },
                React.createElement(Typography, { component: "h1", variant: "h3" }, title)),
            headerChildren,
            addText && addAction && React.createElement(Grid, { item: true }, typeof addAction === "string" ?
                React.createElement(Button, { component: RouterLink, to: addAction, color: "primary", variant: "contained" }, addText) :
                React.createElement(Button, { onClick: handleClick, color: "primary", variant: "contained" }, addText))),
        contentAvailable ?
            React.createElement(Paper, null,
                React.createElement(Table, null, children),
                page !== undefined && setPage &&
                    React.createElement(Grid, { container: true, justifyContent: "space-between", alignItems: "center" },
                        React.createElement(Grid, { item: true },
                            React.createElement(Grid, { className: style.gridPage },
                                resource["totalElements"],
                                " \u00E9lement",
                                resource["totalElements"] > 1 ? "s" : "")),
                        React.createElement(Grid, { item: true },
                            React.createElement(Grid, { className: style.gridPage },
                                React.createElement(IconButton, { disabled: page === 0, onClick: () => {
                                        if (page > 0) {
                                            setPage(page - 1);
                                        }
                                    } },
                                    React.createElement(NavigateBeforeIcon, null)),
                                "page: ",
                                page + 1,
                                "/",
                                resource["totalPages"],
                                React.createElement(IconButton, { disabled: page >= resource["totalPages"] - 1, onClick: () => {
                                        setPage(page + 1);
                                    } },
                                    React.createElement(NavigateNextIcon, null)))))) :
            React.createElement(Alert, { severity: "info" }, "Pas de contenu pour le moment."));
};
//# sourceMappingURL=index.js.map